
export const fragmentTariffCapabilityBase = /* GraphQL */ `
  fragment fragmentTariffCapabilityBase on TariffCapability {
    feature {
      lookup_key
      name
      sort
      active
    }
    value
    is_available
    is_unlimited
  }
`;

export const fragmentFeatureUsageBase = /* GraphQL */ `
  fragment fragmentFeatureUsageBase on FeatureUsage {
    feature {
      lookup_key
      name
    }
    used
    limit
    remaining
    is_unlimited
  }
`;

export const fragmentTarifsForCatalog = /* GraphQL */ `
  fragment fragmentTarifsForCatalog on Tarif {
    id
    name
    price
    validity_months
    lookup_key
    is_active
    is_subscribable
    sort
    recommended
    feature_compatible
    maxLeadsCount
    campaign_key
    payButton
    feature_matrix {
      ...fragmentTariffCapabilityBase
    }
  }
  ${fragmentTariffCapabilityBase}
`;

export const fragmentUserTariffState = /* GraphQL */ `
  fragment fragmentUserTariffState on User {
    id
    effective_access {
      valid_until
      feature_values {
        ...fragmentTariffCapabilityBase
      }
    }
    feature_usage {
      ...fragmentFeatureUsageBase
    }
  }
  ${fragmentTariffCapabilityBase}
  ${fragmentFeatureUsageBase}
`;
